const DeliveryAreaType = {
  ADD_DELIVERY_AREA: "ADD_DELIVERY_AREA",
  SET_DELIVERY_AREA_LIST: "SET_DELIVERY_AREA_LIST",
  UPDATE_DELIVERY_AREA: "UPDATE_DELIVERY_AREA",
};

export interface AddDeliveryArea {
  state: string;
  city: string;
  amount: number;
  min_order_amount: number;
}

export interface GetDeliveryArea {
  limit: number;
  search: any;
  page: number;
}

export interface UpdateDeliveryArea {
  id: number;
  state: string;
  city: string;
  amount: number;
  min_order_amount: number;
}

export interface DeleteDeliveryArea {
  id: number;
}

export default DeliveryAreaType;
